// Generated by purs version 0.15.16
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Argonaut_Core from "../Data.Argonaut.Core/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Decode_Error from "../Data.Argonaut.Decode.Error/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as GraphQL_Query from "../GraphQL.Query/index.js";
import * as GraphQL_Shape from "../GraphQL.Shape/index.js";
import * as GraphQL_Type from "../GraphQL.Type/index.js";
import * as Internal_Luxon from "../Internal.Luxon/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var bindFlipped = /* #__PURE__ */ Control_Bind.bindFlipped(Data_Maybe.bindMaybe);
var StudentIsSymbol = {
    reflectSymbol: function () {
        return "Student";
    }
};
var fromUnionTag = /* #__PURE__ */ GraphQL_Shape.fromUnionTag(StudentIsSymbol)();
var gDecodeJsonCons = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString));
var nameIsSymbol = {
    reflectSymbol: function () {
        return "name";
    }
};
var colorIsSymbol = {
    reflectSymbol: function () {
        return "color";
    }
};
var tagsIsSymbol = {
    reflectSymbol: function () {
        return "tags";
    }
};
var preferred_nameIsSymbol = {
    reflectSymbol: function () {
        return "preferred_name";
    }
};
var last_imported_atIsSymbol = {
    reflectSymbol: function () {
        return "last_imported_at";
    }
};
var idIsSymbol = {
    reflectSymbol: function () {
        return "id";
    }
};
var account_typeIsSymbol = {
    reflectSymbol: function () {
        return "account_type";
    }
};
var accountIsSymbol = {
    reflectSymbol: function () {
        return "account";
    }
};
var rlhsCons = /* #__PURE__ */ GraphQL_Shape.rlhsCons(GraphQL_Shape.rlhsNil);
var maybeShape = /* #__PURE__ */ GraphQL_Shape.maybeShape(GraphQL_Shape.scalarShape);
var StudentAccount = /* #__PURE__ */ (function () {
    function StudentAccount() {

    };
    StudentAccount.value = new StudentAccount();
    return StudentAccount;
})();
var TeacherAccount = /* #__PURE__ */ (function () {
    function TeacherAccount() {

    };
    TeacherAccount.value = new TeacherAccount();
    return TeacherAccount;
})();
var BoardAccount = /* #__PURE__ */ (function () {
    function BoardAccount() {

    };
    BoardAccount.value = new BoardAccount();
    return BoardAccount;
})();
var eqAccType = {
    eq: function (x) {
        return function (y) {
            if (x instanceof StudentAccount && y instanceof StudentAccount) {
                return true;
            };
            if (x instanceof TeacherAccount && y instanceof TeacherAccount) {
                return true;
            };
            if (x instanceof BoardAccount && y instanceof BoardAccount) {
                return true;
            };
            return false;
        };
    }
};
var decodeAccType = {
    decodeJson: function (json) {
        var v = Data_Argonaut_Core.toString(json);
        if (v instanceof Data_Maybe.Just && v.value0 === "STUDENT") {
            return new Data_Either.Right(StudentAccount.value);
        };
        if (v instanceof Data_Maybe.Just && v.value0 === "TEACHER") {
            return new Data_Either.Right(TeacherAccount.value);
        };
        if (v instanceof Data_Maybe.Just && v.value0 === "BOARD_ADMIN") {
            return new Data_Either.Right(BoardAccount.value);
        };
        return new Data_Either.Left(new Data_Argonaut_Decode_Error.TypeMismatch("AccountType"));
    }
};
var queryAccountInfo = /* #__PURE__ */ (function () {
    var process = function (v) {
        return {
            type: v.account_type,
            student: bindFlipped(fromUnionTag(Type_Proxy["Proxy"].value))(v.account)
        };
    };
    return GraphQL_Query.nameQuery("AccountInfo")(Data_Functor.map(GraphQL_Query.queryFunctor)(process)(GraphQL_Query.buildQuery(GraphQL_Query.rlTVars(GraphQL_Query.rltvNil)(GraphQL_Query.rltvfNil)())(GraphQL_Query.jsonQR(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(GraphQL_Shape.unionDecode(GraphQL_Shape.unDecCons(GraphQL_Shape.unDecNil)(StudentIsSymbol)(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(GraphQL_Type.decRNTY(Data_Argonaut_Decode_Class.decodeJsonString)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Internal_Luxon.decodeLDT))(gDecodeJsonCons(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(gDecodeJsonCons(gDecodeJsonCons(Data_Argonaut_Decode_Class.gDecodeJsonNil)(nameIsSymbol)()())(colorIsSymbol)()())())))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(tagsIsSymbol)()())(preferred_nameIsSymbol)()())(nameIsSymbol)()())(last_imported_atIsSymbol)()())(idIsSymbol)()())())()())()))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeFieldId(decodeAccType))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(account_typeIsSymbol)()())(accountIsSymbol)()())())(GraphQL_Shape.recShape(GraphQL_Shape.rlhsCons(rlhsCons(account_typeIsSymbol)(GraphQL_Shape.scalarShape)()())(accountIsSymbol)(GraphQL_Shape.maybeShape(GraphQL_Shape.unionShape(GraphQL_Shape.varhsCons(GraphQL_Shape.varhsNil)(StudentIsSymbol)(GraphQL_Shape.recShape(GraphQL_Shape.rlhsCons(GraphQL_Shape.rlhsCons(GraphQL_Shape.rlhsCons(GraphQL_Shape.rlhsCons(rlhsCons(tagsIsSymbol)(GraphQL_Shape.arrayShape(GraphQL_Shape.recShape(GraphQL_Shape.rlhsCons(rlhsCons(nameIsSymbol)(GraphQL_Shape.scalarShape)()())(colorIsSymbol)(GraphQL_Shape.scalarShape)()())()))()())(preferred_nameIsSymbol)(maybeShape)()())(nameIsSymbol)(GraphQL_Shape.scalarShape)()())(last_imported_atIsSymbol)(maybeShape)()())(idIsSymbol)(GraphQL_Shape.scalarShape)()())())()())()))()())()))("me")({})));
})();
export {
    StudentAccount,
    TeacherAccount,
    BoardAccount,
    queryAccountInfo,
    eqAccType,
    decodeAccType
};
//# sourceMappingURL=index.js.map
